import React from 'react';
import Icon from 'components/Icon';
import { VisibilityContext } from 'react-horizontal-scrolling-menu';

export function RightArrow() {
  const { isLastItemVisible, scrollNext } = React.useContext(VisibilityContext);
  return isLastItemVisible ? null : (
    <div
      className="carousel-button button-next"
      onClick={() => scrollNext()}
      role="button"
      aria-label="next"
    >
      <Icon name="chevron-right" size="large" />
    </div>
  );
}
